import React from 'react';
export const NightlyDamage = () => {
  return <section className="mb-12" data-id="element-173">
      <h2 className="text-2xl font-bold text-blue-900 mb-4" data-id="element-174">
        The Nightly Damage Report
      </h2>
      <p className="text-gray-700 mb-6" data-id="element-175">
        Here's what happens to your face every single night on a cotton
        pillowcase:
      </p>
      <div className="grid md:grid-cols-3 gap-6 mb-8" data-id="element-176">
        <div className="bg-blue-50 p-4 rounded-lg shadow" data-id="element-177">
          <h3 className="text-lg font-bold text-blue-900 mb-2" data-id="element-178">
            Hour 1-2: The Friction Begins
          </h3>
          <ul className="list-disc pl-6 text-gray-700 space-y-2" data-id="element-179">
            <li data-id="element-180">
              Cotton's rough fibers create thousands of micro-abrasions per hour
            </li>
            <li data-id="element-181">
              Delicate facial skin experiences constant tugging and pulling
            </li>
            <li data-id="element-182">
              Natural oils and expensive skincare products get absorbed into
              cotton fibers
            </li>
          </ul>
        </div>
        <div className="bg-blue-50 p-4 rounded-lg shadow" data-id="element-183">
          <h3 className="text-lg font-bold text-blue-900 mb-2" data-id="element-184">
            Hour 3-5: The Compression Effect
          </h3>
          <ul className="list-disc pl-6 text-gray-700 space-y-2" data-id="element-185">
            <li data-id="element-186">
              Your head's full weight (11-15lbs) compresses facial skin against
              rough cotton
            </li>
            <li data-id="element-187">
              Repeated folding in the same spots begins etching temporary "sleep
              lines"
            </li>
            <li data-id="element-188">Skin dehydration accelerates as moisture is wicked away</li>
          </ul>
        </div>
        <div className="bg-blue-50 p-4 rounded-lg shadow" data-id="element-189">
          <h3 className="text-lg font-bold text-blue-900 mb-2" data-id="element-190">
            Hour 6-8: The Permanent Damage
          </h3>
          <ul className="list-disc pl-6 text-gray-700 space-y-2" data-id="element-191">
            <li data-id="element-192">Collagen fibers begin breaking down from repeated stress</li>
            <li data-id="element-193">Temporary sleep lines start becoming permanent wrinkles</li>
            <li data-id="element-194">Skin loses elasticity from nightly trauma</li>
          </ul>
        </div>
      </div>
      <p className="text-gray-700 mb-6 font-semibold text-center" data-id="element-195">
        The horrifying math: Nearly 3,000 hours per year of aging acceleration.
      </p>
      <blockquote className="italic text-gray-700 border-l-4 border-blue-900 pl-4 py-2 mb-8" data-id="element-196">
        "It's like folding a piece of paper in the same spot every night for
        years," Dr. Grant explains. "Eventually, that fold becomes permanent.
        That's exactly what's happening to your face."
      </blockquote>
      <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-197">
        <div className="md:w-1/2" data-id="element-198">
          <h3 className="text-xl font-bold text-blue-900 mb-3" data-id="element-199">
            The Left vs. Right Side Proof
          </h3>
          <p className="text-gray-700 mb-4" data-id="element-200">
            Dr. Grant started documenting something dermatologists had noticed
            for decades but never discussed:
          </p>
          <p className="text-gray-700 mb-4 font-semibold" data-id="element-201">
            Asymmetrical aging patterns that perfectly matched sleep positions.
          </p>
          <blockquote className="italic text-gray-700 border-l-4 border-blue-900 pl-4 py-2 mb-4" data-id="element-202">
            "I could tell which side a patient slept on just by looking at their
            face," she reveals. "The side they favored always showed more
            wrinkles, deeper nasolabial folds, and more pronounced sleep lines."
          </blockquote>
        </div>
        <div className="md:w-1/2" data-id="element-203">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hPHzf92UJrqXPeNaqEA2cs/20253333333333333.png" alt="Side-by-side comparison: Woman sleeping on cotton pillow with visible wrinkles and discomfort (left) vs woman sleeping on silk pillow with smooth, relaxed skin (right)" className="rounded-lg shadow-lg w-full" data-id="element-204" />
        </div>
      </div>
    </section>;
};